export const menu = {
    label: 'Parâmetros',
    icon: 'pi pi-fw pi-cog',
    to: '/administracao/parametros',
    rules: ['PARAM-00'],
};
